enum UpTakeRoutes {
  List = '/uptake',
  Item = '/uptake/:id',
}

export default UpTakeRoutes
